var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { RadioGroup, Radio } from 'ui/styled';
import StarFullIcon from 'assets/star_full.png';
import StarEmptyIcon from 'assets/star_empty.png';
import { getIcon } from 'utils/helpers';
import { LIGHT_GREY } from 'ui/constants';
var STAR_MAX = 5;
var ratings = Array.from({ length: STAR_MAX }, function (n, i) { return "".concat(i + 1); });
var ratingsReverse = __spreadArray([], ratings, true).reverse();
var MinRatingRadio = function (_a) {
    var onChange = _a.onChange, value = _a.value;
    return (_jsxs(RadioGroup, { onChange: onChange, value: value, direction: "column", children: [ratingsReverse.map(function (item) {
                var itemNum = +item;
                return (_jsxs(Radio, { lineHeight: "30px", color: LIGHT_GREY, "data-test": "radioRatingBtn".concat(item), value: item, children: [ratings.map(function (i) {
                            if (itemNum - +i >= 0)
                                return (_jsx("span", { children: getIcon(StarFullIcon, 16, 14, { marginRight: 5 }) }, "".concat(item, ",").concat(i)));
                            return (_jsx("span", { children: getIcon(StarEmptyIcon, 16, 14, { marginRight: 5 }) }, "".concat(item, ",").concat(i)));
                        }), "".concat(itemNum !== STAR_MAX ? '& Up' : '')] }, item));
            }), _jsxs(Radio, { lineHeight: "30px", color: LIGHT_GREY, "data-test": "radioRatingDefaultBtn", value: undefined, children: [ratings.map(function (i) {
                        return _jsx("span", { children: getIcon(StarEmptyIcon, 16, 14, { marginRight: 5 }) }, "".concat(i, "_def"));
                    }), "& Up"] }, "default")] }));
};
export default MinRatingRadio;
